module.exports = __webpack_public_path__ + "img/pt-32.da55d4be.jpg";